// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"d1df6c77","455":"99592e26","977":"80164607"}[chunkId] + ".chunk.js";
};